export interface LightProbeGenerationParams {
  lightProbeNear: number;
  lightProbeFar: number;
  lightProbeBounces: number;
}

export const defaultLightProbeGenerationParams = {
  lightProbeNear: 2.0,
  lightProbeFar: 1000.0,
  lightProbeBounces: 1,
};
